import React from 'react';

export default function UpcomingList({ coopArticle }) {
  const resultsRender = [];

  for (let i = 0; i < coopArticle.length; i += 3) {
    resultsRender.push(
      <>
        <div data-card-size="small" className="grid card__grid">
          {coopArticle.slice(i, i + 3).map((i) => (
            <div className="grid__col-lg-4 grid__col-xs-12">
              <article
                key={i.id}
                className={`card ${i.sponsored ? 'card--sponsored' : ''}`}
              >
                <a href={i.url}>
                  <img src={i.image} className="card__media" alt={i.title} />
                  <section className="card__body card__body--small">
                    <p className="card__category">{i.kicker}</p>
                    <h4
                      className="card__title"
                      dangerouslySetInnerHTML={{ __html: i.title }}
                    ></h4>
                    <p className="card__description">{i.subheader}</p>
                  </section>
                </a>
                <hr className="card__hr" />
              </article>
            </div>
          ))}
        </div>
        <hr className="section__hr" />
      </>
    );
  }

  return <>{resultsRender}</>;
}
